﻿$.fn.dxCtrlContentEmailBase = function custom_dxCtrlContentEmailBase(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcontentemailbase dx-ctrl");
        this.createInstance(new cdxCtrlContentEmailBase(this, option));
    }
    return this;
}

//const NOMBRE_DESTINATAIRE_A_CC_CCI_MAX = 30
window.cdxCtrlContentEmailBase = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    if (typeof option.objetVisible == 'undefined') option.objetVisible = true
    if (typeof option.showChangerModele == 'undefined') option.showChangerModele = true

    var jauge = null
    var $DivEntete = null
    var dxToolBar = null
    this.mGetDxToolbar = function () { return dxToolBar }
    var isDirtyTest = false
    var isDirty = false
    this.isDirty = function (value) {
        if (typeof value != 'undefined') {
            isDirty = value
            if (dxCtrlObjet) dxCtrlObjet.isDirty = value
            dxCtrlFichierJoint.isDirty(value)
            dxEmailEditor.isDirty(value)
            isDirtyTest = value
        }
        return ((dxCtrlObjet) ? dxCtrlObjet.isDirty : false) || ((dxCtrlFichierJoint) ? dxCtrlFichierJoint.isDirty(value) : false) || ((dxEmailEditor) ? dxEmailEditor.isDirty(value) : false) || isDirtyTest || isDirty
    }

    this.isInit = function () { return dxEmailEditor.isInit }

    var dataHtml = null
    var dxCtrlObjet = null
    var $TdAddFile = null
    var dxBtUndo = null
    var dxBtRedo = null
    function mConstruit() {
        container.empty()
        container.addClass("dx-theme-material-typography")
        jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance")
        if (typeof option.data64 != 'undefined') {
            if (option.data64 == null || option.data64.length == 0) {
                dataHtml = {
                    lstfile: [],
                    lstfileheberge: [],
                    objet: "",
                    html: "<html><body></body></html>",
                    urlHtml: "",
                    idTestAcid: "",
                    dateTestAcid: "",
                    lstChampSaisie: []
                }
                mRempli()
            } else {
                option.bddCtrl.mAjaxCall({
                    command: "getdataemailbase64",
                    data_base64: option.data64
                }, function (data) {
                    if (typeof data.lstfile == "undefined") data.lstfile = []
                    if (typeof data.lstfileheberge == "undefined") data.lstfileheberge = []
                    if (typeof data.lst_champ_saisie == "undefined") data.lst_champ_saisie = "[]"
                    data.lstChampSaisie = JSON.parse(data.lst_champ_saisie)
                    delete data.lst_champ_saisie
                    dataHtml = data
                    mRempli()
                })
            }
        } else if (typeof option.data.id_fichier != 'undefined') {
            option.bddCtrl.mAjaxCall({
                command: "getdataemailfichier",
                path_nom_fichier: option.data.id_fichier
            }, function (data) {
                if (typeof data.lstfile == "undefined") data.lstfile = []
                if (typeof data.lstfileheberge == "undefined") data.lstfileheberge = []
                if (typeof data.lst_champ_saisie == "undefined") data.lst_champ_saisie = "[]"
                data.lstChampSaisie = JSON.parse(data.lst_champ_saisie)
                delete data.lst_champ_saisie
                dataHtml = data
                option.data.taille_octet = data.taille_octet
                option.data.taille_octet_ss_image = data.taille_octet_ss_image
                mRempli()
            })
        } else {
            if (option.bddCtrl.getObjet(option.data).cle() != null) {
                option.bddCtrl.mAjaxCall({
                    command: "getdataemailbdd",
                    nom_table: option.bddCtrl.getObjet(option.data).mGetTable().nom,
                    id: option.bddCtrl.getObjet(option.data).cle()
                }, function (data) {
                    //lstFile,objet,html/urlhtml
                    if (typeof data.lstfile == "undefined") data.lstfile = []
                    if (typeof data.lstfileheberge == "undefined") data.lstfileheberge = []
                    if (typeof data.lst_champ_saisie == "undefined") data.lst_champ_saisie = "[]"
                    data.lstChampSaisie = JSON.parse(data.lst_champ_saisie)
                    delete data.lst_champ_saisie
                    dataHtml = data
                    mRempli()
                })
            } else {
                if (typeof option.lstUrlFileJoinStart == 'undefined') option.lstUrlFileJoinStart = []
                dataHtml = {
                    lstfile: option.lstUrlFileJoinStart,
                    lstfileheberge: [],
                    objet: option.data.objet,
                    html: "<html><body>" + ((option.htmlText) ? option.htmlText : "") + "</body></html>",
                    urlHtml: "",
                    idTestAcid: "",
                    dateTestAcid: "",
                    lstChampSaisie: []
                }
                mRempli()
            }
        }

        function mRempli() {
            $DivEntete = $("<div/>").appendTo(container)
            if (parametre.isMobile) $DivEntete.css("padding", "0 10px")
            if (typeof option.showObjetFile != 'undefined' && !option.showObjetFile) $DivEntete.css("display", "none")
            var $TableObjet = $("<table style='width:100%;margin:5px 0;'/>").appendTo(((typeof option.containerObjet == 'undefined') ? $DivEntete : option.containerObjet))
            var $TrObjet = $("<tr/>").appendTo($TableObjet)
            $TdAddFile = $("<td style='width:0px;'/>").appendTo($TrObjet)
            if (option.hideAddFile) $TdAddFile.css("display","none")
            var $TdObjet = $("<td style='width:100%;'/>").appendTo($TrObjet)
            if (typeof option.showObjet != 'undefined' && !option.showObjet) {
                $TableObjet.css("display", "none")
                $TdObjet.css("display", "none")
                $TdAddFile = null
            }
            if (option.readOnly) {
                $("<div/>").appendTo($TdObjet).dxCtrlTextBox({
                    labelMode: 'floating',
                    label: ((typeof option.labelObjet != 'undefined') ? option.labelObjet : "Objet"),
                    visible: option.objetVisible,
                    readOnly: true,
                    value: dataHtml.objet
                }).dxCtrlTextBox("instance")
            } else {
                dxCtrlObjet = $("<div style='" + ((!option.objetVisible) ? "display:none;" : "") + "'/>").appendTo($TdObjet).dxCtrlTxtObjet({
                    labelMode: 'floating',
                    label: ((typeof option.labelObjet != 'undefined') ? option.labelObjet : "Objet"),
                    showPersonnalisation: false,
                    bddCtrl: option.bddCtrl,
                    value: dataHtml.objet,
                    placeholder: "Objet...",
                    onValueChanged: function (value) {
                        if (typeof option.onChangeObjet != 'undefined') option.onChangeObjet(value)
                    },
                    onLoad: function () {
                        if (!option.objetVisible) {
                            window.setTimeout(function () { dxCtrlObjet.element().hide() }, 0)
                        }
                        window.setTimeout(function () { Me.focus() }, 300)
                    }
                }).dxCtrlTxtObjet("instance")
                //dxCtrlObjet = $("<div style='" + ((!option.objetVisible) ? "display:none;" : "") + "'/>").appendTo($TdObjet).dxCtrlTxtEmoji({
                //    bddCtrl: option.bddCtrl,
                //    value: dataHtml.objet,
                //    placeholder: "Objet...",
                //    onValueChanged: function (value) {
                //        if (typeof option.onChangeObjet != 'undefined') option.onChangeObjet(value)
                //    },
                //    onLoad: function () {
                //        if (!option.objetVisible) $($TdObjet.find(".emojionearea")).hide()
                //        window.setTimeout(function () { Me.focus() }, 300)
                //    }
                //}).dxCtrlTxtEmoji("instance")
            }

            //var dxSelectProjet = null
            //if (option.bddCtrl.objCptCli.objetMetier.hasProjet() && !parametre.isMobile &&
            //    typeof option.data64 == 'undefined' &&
            //    option.bddCtrl.getObjet(option.data).mGetTable().id_table != 0) {
            //    if (option.bddCtrl.utiCourantParaJson.parametre_general.email_afficher_selection_projet_dans_fenetre) {
            //        $TdObjet.css("width", "75%")
            //        var $TdProjet = $("<td style='width:25%;'/>").appendTo($TrObjet)
            //        dxSelectProjet = $("<div style='padding:0 0px 0 10px;'/>").appendTo($TdProjet).dxCtrlSelectProjet({
            //            bddCtrl: option.bddCtrl,
            //            data: option.data,
            //            onChanging: function (funcChange) {
            //                var obj = option.bddCtrl.getObjet(option.data)
            //                if (obj.cle() == null) {
            //                    obj.mSave(function () { if (typeof funcChange != 'undefined') funcChange() })
            //                } else { if (typeof funcChange != 'undefined') funcChange() }
            //            }
            //        })
            //    }
            //}

            if (option.bddCtrl.utiCourantParaJson.parametre_general.email_afficher_selection_classeur_dans_fenetre && !parametre.isMobile &&
                typeof option.data64 == 'undefined' &&
                option.bddCtrl.getObjet(option.data).mGetTable().nom == "com_email_envoi") {
                //$TdObjet.css("width", ((dxSelectProjet) ? "50%" : "75%"))
                $TdObjet.css("width", "75%")
                var $TdClasseur = $("<td style='width:25%;'/>").appendTo($TrObjet)
                var obj = option.bddCtrl.getObjet(option.data)
                $("<div/>").appendTo($TdClasseur).dxCtrlSelectClasseur({
                    bddCtrl: option.bddCtrl,
                    idTable: option.bddCtrl.table.mGetItemFromNom("com_email_envoi").id_table,
                    id: obj.cle(),
                    onDemandeSave: function (funcSaved) {
                        var obj = option.bddCtrl.getObjet(option.data)
                        if (obj.cle() == null) {
                            obj.mSave(function () { if (typeof funcSaved != 'undefined') funcSaved(obj.cle()) })
                        } else {
                            if (typeof funcSaved != 'undefined') funcSaved(obj.cle())
                        }
                    }
                })
            }


            if (!parametre.isMobile) {
                var $Table = $("<table style='width:100%'/>").appendTo(((typeof option.containerObjet == 'undefined') ? $DivEntete : option.containerObjet))
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:0px;'/>").appendTo($Tr)
                if (option.hideAddFile) $Td.css("display", "none")
                if (typeof option.showObjet != 'undefined' && !option.showObjet) $TdAddFile = $Td
                var $TdToolBar = $("<td style='width:100%;'/>").appendTo($Tr)
                var lstButton = [{
                    location: 'before',
                    widget: 'dxButton',
                    showText: "always",
                    visible: typeof option.data64 == 'undefined',
                    options: {
                        text: 'Prévisualiser',
                        hint:"Prévisualisez votre email<br>(les tracking, les liens de visualisation navigateur et de désinscription sont désactivés dans la prévisualisation)",
                        focusStateEnabled: false,
                        tabIndex: -1, // <-- empêche le focus clavier
                        onClick(e) {
                            e.event.stopPropagation();
                            Me.mSaveAuto(function () {
                                if (typeof option.onDemandePrevisualisation != 'undefined') { option.onDemandePrevisualisation() }
                                else { mShowPrevi(); }
                            })
                        }
                    }
                }, {
                    location: 'before',
                    widget: 'dxButton',
                    showText: "always",
                    template(itemData, itemIndex, itemElement) {
                        var opt = {
                            icon: 'fas fa-rotate-left',
                            txtTooltip: "Annuler",
                            focusStateEnabled: false,
                            tabIndex: -1, // <-- empêche le focus clavier
                            visible: false,
                            onClick: function (e) {
                            }
                        }
                        dxBtUndo = $("<div/>").appendTo(itemElement).dxCtrlButton(opt).dxCtrlButton("instance");
                    }
                }, {
                    location: 'before',
                    widget: 'dxButton',
                    showText: "always",
                    template(itemData, itemIndex, itemElement) {
                        var opt = {
                            icon: 'fas fa-rotate-right',
                            txtTooltip: "Rétablir",
                            focusStateEnabled: false,
                            tabIndex: -1, // <-- empêche le focus clavier
                            visible: false,
                            onClick: function (e) {
                            }
                        }
                        dxBtRedo = $("<div/>").appendTo(itemElement).dxCtrlButton(opt).dxCtrlButton("instance");
                    }
                }]
                if (typeof option.lstButtonBefore != 'undefined') lstButton = lstButton.concat(option.lstButtonBefore)
                if (option.showChangerModele) {
                    var lstItem = ["Sauvegarder dans la box".toUpperCase()]
                    if (parametre.code_appli=="ppmasc") lstItem.push("Sauvegarder dans la box comme formulaire".toUpperCase())
                    lstButton.push({
                        location: 'after',
                        widget: 'dxDropDownButton',
                        showText: "always",
                        options: {
                            items: lstItem,
                            text: 'Changer modèle',
                            focusStateEnabled: false,
                            tabIndex: -1, // <-- empêche le focus clavier
                            splitButton: true,
                            dropDownOptions: { width: 380 },
                            onButtonClick(e) {
                                //changer de modèle
                                e.event.stopPropagation();
                                $("<div/>").appendTo("body").dxCtrlSelectModele({
                                    bddCtrl: option.bddCtrl,
                                    type: "email",
                                    disableConcepteurSignature: option.disableConcepteurSignature,
                                    disableDocEnvoiBrouillon: option.disableDocEnvoiBrouillon,
                                    onSelectEditeur: function () {
                                        Me.mChangeHtml("<html><body></body></html>", "", function () {
                                            jaugeDemarrage.mHide()
                                        })
                                        isDirty = true
                                    },
                                    onSelectConcepteurVide: function () {
                                        Me.mChangeHtml('<html assistant2="1"><body></body></html>', "", function () {
                                            jaugeDemarrage.mHide()
                                        })
                                        isDirty = true
                                    },
                                    onSelectFile: function (pathName) {
                                        mChargeSelectedModele(pathName, null)
                                        isDirty = true
                                    },
                                    onSelectData: function (dataGrid) {
                                        mChargeSelectedModele(null, dataGrid)
                                        isDirty = true
                                    }
                                }).dxCtrlSelectModele("instance")

                                function mChargeSelectedModele(pathName, dataGrid) {
                                    jaugeDemarrage.mShow()
                                    if (pathName != null) {
                                        //Fichier modèle ou Fichier de la box
                                        option.bddCtrl.mAjaxCall({ command: "getdatafichieremlz", id_fichier: pathName }, function (data) {
                                            Me.mChangeObjet(data.objet)
                                            if (isFileData()) option.data.objet = data.objet
                                            Me.mClearFiles()
                                            if (typeof data.lstfile != 'undefined') Me.mAddFiles(data.lstfile)
                                            Me.mClearFilesHeberge()
                                            if (typeof data.lstfileheberge != 'undefined') Me.mAddFilesHeberge(data.lstfileheberge)
                                            Me.mChangeLstChampsSaisie(JSON.parse(data.lst_champ_saisie))

                                            if (isFileData() && option.data.presentation_mailing == "0") {
                                                // Convertir la string en objet jQuery (en important uniquement <html>)
                                                var doc = new DOMParser().parseFromString(data.html, 'text/html');
                                                var $html = $(doc.documentElement);
                                                if ($html.attr('assistant2') === '1') {
                                                    //on est pas en présentation mailing et on a un concepteur 
                                                    jaugeDemarrage.mHide()
                                                    var popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
                                                        width: 400,
                                                        height: "auto",
                                                        showMaximize: false,
                                                        contentTemplate: function (contentElement) {
                                                            contentElement.css("padding-top", "0")
                                                            $("<div style='text-align:center;'>Vous allez charger un modèle issu du concepteur.<br>Que voulez vous faire ?</div>").appendTo(contentElement)
                                                            $("<div style='margin:5px;'/>").appendTo(contentElement).dxCtrlButton({
                                                                html: "charger en mode éditeur<br/>avec signature",
                                                                width: "100%",
                                                                onClick: function (e) {
                                                                    popup.hide()
                                                                    option.bddCtrl.mAjaxCall({
                                                                        command: "getdatasignature",
                                                                        id_compte_email: option.data.id_compte_email,
                                                                        id_utilisateur: option.bddCtrl.utiCourant.id_utilisateur
                                                                    }, function (dataSignature) {
                                                                        var doctypeMatch = data.html.match(/<!DOCTYPE[^>]*>/i);
                                                                        var doctype = doctypeMatch ? doctypeMatch[0] : '<!DOCTYPE html>';

                                                                        var doc = new DOMParser().parseFromString(dataSignature.html, 'text/html');

                                                                        // Convertir en DOM
                                                                        var doc = new DOMParser().parseFromString(dataSignature.html, 'text/html');
                                                                        var $html = $(doc.documentElement);
                                                                        var bodySignature = "<div>" + $($html.find('body')[0]).html() + "</div>";


                                                                        var doc = new DOMParser().parseFromString(data.html, 'text/html');
                                                                        var div = document.createElement('div');
                                                                        //div.innerHTML = bodySignature; // bodySignature peut être une string HTML
                                                                        //doc.body.parentNode.insertBefore(div, doc.body.nextSibling);
                                                                        doc.body.insertAdjacentHTML('afterbegin', bodySignature);

                                                                        var $html = $(doc.documentElement);
                                                                        $html.removeAttr('assistant2');
                                                                        $html.find('.AViewBrowser').remove();
                                                                        $html.find('.ADesinscription').remove();
                                                                        $html.find('#cssbaseV1').remove();

                                                                        var serializer = new XMLSerializer();
                                                                        data.html = doctype + serializer.serializeToString(doc.documentElement);


                                                                        var $htmlSsBody = $('<div>').html(data.htmlSansBody);
                                                                        $htmlSsBody.find('.AViewBrowser').remove();
                                                                        $htmlSsBody.find('.ADesinscription').remove();
                                                                        $html.find('#cssbaseV1').remove();
                                                                        data.htmlSansBody = bodySignature + $htmlSsBody.html()

                                                                        Me.mChangeHtml(data.html, data.htmlSansBody, function () {
                                                                            jaugeDemarrage.mHide()
                                                                            isDirty = true
                                                                        })
                                                                    })
                                                                }
                                                            })
                                                            $("<div style='margin:5px;'/>").appendTo(contentElement).dxCtrlButton({
                                                                text: "charger en mode éditeur",
                                                                width: "100%",
                                                                onClick: function (e) {
                                                                    popup.hide()
                                                                    var doctypeMatch = data.html.match(/<!DOCTYPE[^>]*>/i);
                                                                    var doctype = doctypeMatch ? doctypeMatch[0] : '<!DOCTYPE html>';

                                                                    var bodySignature = "<div></div>";

                                                                    var doc = new DOMParser().parseFromString(data.html, 'text/html');
                                                                    var div = document.createElement('div');
                                                                    //div.innerHTML = bodySignature; // bodySignature peut être une string HTML
                                                                    //doc.body.parentNode.insertBefore(div, doc.body.nextSibling);
                                                                    doc.body.insertAdjacentHTML('afterbegin', bodySignature);

                                                                    var $html = $(doc.documentElement);
                                                                    $html.removeAttr('assistant2');
                                                                    $html.find('.AViewBrowser').remove();
                                                                    $html.find('.ADesinscription').remove();
                                                                    $html.find('#cssbaseV1').remove();

                                                                    var serializer = new XMLSerializer();
                                                                    data.html = doctype + serializer.serializeToString(doc.documentElement);

                                                                    var $htmlSsBody = $('<div>').html(data.htmlSansBody);
                                                                    $htmlSsBody.find('.AViewBrowser').remove();
                                                                    $htmlSsBody.find('.ADesinscription').remove();
                                                                    $html.find('#cssbaseV1').remove();
                                                                    data.htmlSansBody = $htmlSsBody.html()

                                                                    Me.mChangeHtml(data.html, data.htmlSansBody, function () {
                                                                        jaugeDemarrage.mHide()
                                                                        isDirty = true
                                                                    })
                                                                }
                                                            })
                                                            $("<div style='margin:5px;'/>").appendTo(contentElement).dxCtrlButton({
                                                                text: "charger en mode concepteur",
                                                                width: "100%",
                                                                onClick: function (e) {
                                                                    popup.hide()
                                                                    Me.mChangeHtml(data.html, data.htmlSansBody, function () {
                                                                        jaugeDemarrage.mHide()
                                                                        isDirty = true
                                                                    })
                                                                }
                                                            })
                                                        }
                                                    }).dxCtrlPopupBase("instance")
                                                    popup.show()
                                                } else {
                                                    Me.mChangeHtml(data.html, data.htmlSansBody, function () {
                                                        jaugeDemarrage.mHide()
                                                        isDirty = true
                                                    })
                                                }
                                            } else {
                                                Me.mChangeHtml(data.html, data.htmlSansBody, function () {
                                                    jaugeDemarrage.mHide()
                                                    isDirty = true
                                                })
                                            }
                                        })
                                    } else if (dataGrid != null) {
                                        //fichier de la base
                                        option.bddCtrl.mAjaxCall({ command: "getdataemailbdd", nom_table: "com_email_envoi", id: dataGrid.id }, function (data) {
                                            Me.mChangeObjet(data.objet)
                                            if (isFileData()) option.data.objet = data.objet
                                            Me.mClearFiles()
                                            if (typeof data.lstfile != 'undefined') Me.mAddFiles(data.lstfile)
                                            Me.mClearFilesHeberge()
                                            if (typeof data.lstfileheberge != 'undefined') Me.mAddFilesHeberge(data.lstfileheberge)
                                            Me.mChangeLstChampsSaisie(JSON.parse(data.lst_champ_saisie))
                                            Me.mChangeHtml(data.html, data.htmlSansBody, function () {
                                                jaugeDemarrage.mHide()
                                                isDirty = true
                                            })
                                        })
                                    }
                                }

                            },
                            onItemClick(e) {
                                debugger;
                                //sauvegarder comme modèle
                                //if (option.bddCtrl.objCptCli.objetMetier.hasBox()) {
                                if (Me.isDirty()) {
                                    Me.mSave(function () { mFinalise() })
                                } else { mFinalise() }
                                function mFinalise() {
                                    var objet = ""
                                    if (dxCtrlObjet) objet = dxCtrlObjet.mGetValue()
                                    if (typeof objet == "undefined" || objet == null || objet.length == 0) objet = (lstItem.indexOf(e.itemData) == 0 ? "Nouveau document email" : "Nouveau document formulaire")
                                    objet = objet.remplacerTout(" ", "_")
                                    objet = objet.remplacerTout(carInterditFichier, "")
                                    if (objet.length > 50) objet = objet.substring(0, 50)
                                    //objet += ".emlz"
                                    var extension =  (lstItem.indexOf(e.itemData) == 0 ? ".emlz" : ".formz")
                                    pathNomFichier = option.bddCtrl.repertoireBrouillon + "/" + objet + extension

                                    Me.mDemandeExport(objet, pathNomFichier, extension)
                                    //$("<div/>").dxCtrlPopupEnregistrerSous({
                                    //    bddCtrl: option.bddCtrl,
                                    //    extension: ".emlz",
                                    //    mode: "single",
                                    //    type: "enregistrersous",
                                    //    selectedDirectory: option.bddCtrl.repertoireBrouillon,
                                    //    fileNameWithoutExtension: objet,
                                    //    title: "Enregistrer sous...",
                                    //    onValide: function (lstPathName) {
                                    //        var pathName = lstPathName[0]
                                    //        if (pathName == pathNomFichier) {
                                    //            Me.mExportBox(pathName, function () {
                                    //                mNotify("Votre document a été sauvegardé", "success", 6000)
                                    //            })
                                    //        } else {
                                    //            mVerifFileExist(option.bddCtrl, pathName, function (exist) {
                                    //                if (exist) {
                                    //                    mConfirmPopup("<div style='padding-bottom:20px;'>Le fichier que vous avez choisi<br/>existe déjà.<br/><br/>Voulez-vous remplacer le fichier<br/>avec votre document ?</div>", function () {
                                    //                        Me.mExportBox(pathName, function () {
                                    //                            mNotify("Votre document a été sauvegardé", "success", 6000)
                                    //                        })
                                    //                    })
                                    //                } else {
                                    //                    Me.mExportBox(pathName, function () {
                                    //                        mNotify("Votre document a été sauvegardé", "success", 6000)
                                    //                    })
                                    //                }
                                    //            })
                                    //        }

                                    //    }
                                    //})
                                }
                            }
                        }
                    })
                }

                if (typeof option.onSlide != 'undefined') {
                    var isSlideDown = true
                    lstButton.push({
                        location: 'after',
                        widget: 'dxButton',
                        showText: "always",
                        options: {
                            icon: 'fas fa-chevron-up',
                            hint: "Réduire",
                            visible: true,
                            focusStateEnabled: false,
                            tabIndex: -1, // <-- empêche le focus clavier
                            onClick: function (e) {
                                isSlideDown = !isSlideDown
                                if (isSlideDown) {
                                    if ($TrObjet) $TrObjet.slideDown(300)
                                } else {
                                    if ($TrObjet) $TrObjet.slideUp(300)
                                }
                                option.onSlide(isSlideDown)
                                e.component.option("icon", ((isSlideDown) ? 'fas fa-chevron-up' : 'fas fa-chevron-down'))
                                e.component.option("hint", ((isSlideDown) ? 'Réduire' : 'Agrandir'))
                            },
                            onFocusIn: function (e) {
                                e.component.blur(); // retire le focus immédiatement
                            }
                        }
                        //template(itemData, itemIndex, itemElement) {
                        //    var opt = {
                        //    }
                        //    var dxBtSlide = $("<div tabindex='-1'/>").appendTo(itemElement).dxCtrlButton(opt).dxCtrlButton("instance");
                        //}
                    })
                }
                if (option.allowFullScreen) {
                    var isFullScreen = false
                    lstButton.push({
                        location: 'after',
                        widget: 'dxButton',
                        showText: "always",
                        options: {
                            icon: 'dx-icon fas fa-arrow-up-right-from-square',
                            hint: "Agrandir/Réduire",
                            visible: true,
                            focusStateEnabled: false,
                            tabIndex: -1, // <-- empêche le focus clavier
                            onClick: function (e) {
                                isFullScreen = !isFullScreen
                                if (isFullScreen) {
                                    container.css({
                                        "position": "fixed",
                                        top: 0,
                                        left: 0,
                                        "z-index":10
                                    })
                                } else {
                                    container.css({
                                        "position": "relative",
                                        top: "",
                                        left: "",
                                        "z-index":""
                                    })
                                }
                                e.component.option("icon", ((isFullScreen) ? 'fas fa-arrow-up-right-from-square fa-rotate-180' : 'fas fa-arrow-up-right-from-square'))
                            },
                            onFocusIn: function (e) {
                                e.component.blur(); // retire le focus immédiatement
                            }
                        }
                        //template(itemData, itemIndex, itemElement) {
                        //    var opt = {
                        //    }
                        //    var dxBtSlide = $("<div tabindex='-1'/>").appendTo(itemElement).dxCtrlButton(opt).dxCtrlButton("instance");
                        //}
                    })
                }
                if (option.buttonClose) {
                    lstButton.push(getToolbarSeparator("after", "auto"))
                    lstButton.push(option.buttonClose)
                }
                dxToolBar = $("<div style='background-color:transparent'/>").appendTo($TdToolBar).dxToolbar({
                    visible: !option.readOnly,
                    items: lstButton,
                    focusStateEnabled: false,
                    onContentReady: function (e) {
                        e.component.element().find(".dx-toolbar-items-container").css("height", "42px")
                    }
                }).dxToolbar("instance")
                if (option.hideToolbarPrevi) $Table.hide()
            }

            mConstruitFichierJointHtml()

            mConstruitHtml()

            if (option.saveAuto) mStartSaveAuto()

            if (typeof option.onContentReady != 'undefined') option.onContentReady(Me)
        }

    }

    //function mGetTextObjet() {
    //    var value = $InputObjetEmoji.getText()
    //    if (value.length > 0 && value.charCodeAt(value.length - 1) > 255) value += "  "
    //    return value
    //}

    var dxCtrlFichierJoint = null
    function mConstruitFichierJointHtml() {

        var $DivFichier = null
        if (typeof option.containerFile == 'undefined') {
            $DivFichier = $("<div style=''/>").appendTo($DivEntete)
        } else {
            $DivFichier = option.containerFile
        }
        dxCtrlFichierJoint = $("<div/>").appendTo($DivFichier).dxCtrlFichier2Document({
            bddCtrl: option.bddCtrl,
            dataSource: dataHtml.lstfile,
            readOnly: option.readOnly,
            containerBtAdd: $TdAddFile,
            imgInternet: ((option.showOnlyUploadMachine) ? false : !parametre.isMobile),
            box: ((option.showOnlyUploadMachine) ? false : true),
            icone: false,
            docCpt: ((option.showOnlyUploadMachine) ? false : !parametre.isMobile),
            courrier: ((option.showOnlyUploadMachine) ? false : !parametre.isMobile),
            onAdd: function () {
                dataHtml.lstfile = dxCtrlFichierJoint.mGetLstUrlFile()
                if (isFileData()) option.data.nb_fichier_joint = dataHtml.lstfile.length
                mResize()
            },
            onDelete: function (file) {
                dataHtml.lstfile = dxCtrlFichierJoint.mGetLstUrlFile()
                if (isFileData()) option.data.nb_fichier_joint = dataHtml.lstfile.length
                window.setTimeout(function () { mResize() }, 0)
            }
        }).dxCtrlFichier2Document("instance")
    }

    var isFullScreen = false
    var dxEmailEditor = null
    function mConstruitHtml() {
        dxEmailEditor = $("<div/>").appendTo(container).dxCtrlContentEmailEditor({
            bddCtrl: option.bddCtrl,
            dataHtml: dataHtml,
            readOnly: option.readOnly,
            allowAssistant: option.allowAssistant,
            allowMiseEnPage: option.allowMiseEnPage,
            allowMenu: option.allowMenu,
            allowTag: option.allowTag,
            htmlDefaut: option.htmlDefaut,
            buttons: option.buttons,
            fullScreen: isFullScreen,
            dxBtUndo: dxBtUndo,
            dxBtRedo: dxBtRedo,
            allowJaugeSwitchEditeur: option.allowJaugeSwitchEditeur,
            removeMenuFont: option.removeMenuFont,
            allowFullScreen: option.allowFullScreen,
            allowShowMessageNavigateur: option.allowShowMessageNavigateur,
            allowPreviewTest: (typeof option.data64 == 'undefined'),
            viewInBrowser: (typeof option.data64 == 'undefined'),
            onDemandeUrl: option.onDemandeUrl,
            allowChampForDestinataireForTag: (typeof option.data64 == 'undefined'),
            onDeclencheSaveAuto: function (funcFin) {
                Me.mSaveAuto(funcFin)
            },
            onSwitchFullScreen: function () {
                Me.mSaveAuto(function () {
                    isFullScreen = !isFullScreen
                    mConstruit()
                })
            },
            onDemandePrevisualisation: function () {
                Me.mSaveAuto(function () {
                    if (typeof option.onDemandePrevisualisation != 'undefined') { option.onDemandePrevisualisation() }
                    else { mShowPrevi(); }
                })
            },
            onDemandeIdComEmailEnvoi: function () {
                if (typeof option.data.id_fichier != 'undefined') {
                    return option.data.id_fichier
                } else {
                    return option.bddCtrl.getObjet(option.data).cle()
                }
            },
            onNewTest: function (idTest) {
                isDirtyTest = true
                dataHtml.idTestAcid = idTest
                if (idTest.length > 0) { dataHtml.dateTestAcid = new Date() }
                else { dataHtml.dateTestAcid = "" }
            },
            onDemandeTest: function (funcFin) {
                option.bddCtrl.mAjaxCall({
                    command: "demandetestacidbase64"
                }, function (data) { funcFin(data) })
            },
            onSaveTest: function (idTest) {
                option.bddCtrl.mAjaxCall({
                    command: "savetestacidbase64",
                    idtest: idTest
                })
            },
            onAddFiles: function (lstFile) {
                var lstUrlFiles = []
                lstFile.forEach(function (file) { lstUrlFiles.push(file.url) })
                dxCtrlFichierJoint.mAddFiles(lstUrlFiles)
            },
            onDemandeObjet: function () {
                return ((dxCtrlObjet) ? dxCtrlObjet.mGetValue() : "") //  ((dxCtrlObjet.option("value") == null) ? "" : dxCtrlObjet.option("value"))
            },
            onContentReady: function () {
                if (typeof option.onContentReady != 'undefined' && option.onContentReady != null) option.onContentReady(Me)
            }
        }).dxCtrlContentEmailEditor("instance")
        if (typeof option.showObjetFile == 'undefined' || option.showObjetFile) {
            resizeObserver.mAdd([$DivEntete], function () { mResize() })()
        } else {
            dxEmailEditor.element().css("height", "100%")
        }
    }

    function mResize() {
        if (dxEmailEditor) dxEmailEditor.element().css("height", "calc(100% - " + ($DivEntete.innerHeight() + 10) + "px)")
    }

    function mShowPrevi() {
        jauge.mShow()
        Me.mGetHtmlUrl(function (urlHtml) {
            $("<div/>").appendTo("body").dxCtrlEmailPrevisualisation({
                bddCtrl: option.bddCtrl,
                urlHtml: urlHtml,
                objet: dataHtml.objet,
                getHtml: function () { return dxEmailEditor.mGetHtml() },
                //data: option.data,
                //onDemandeObjet: option.onDemandeObjet,
                //onDemandeHtml: option.onDemandeHtml,
                onDemandeUrl: option.onDemandeUrl,
                idTestAcid: dataHtml.idTestAcid,
                dateTestAcid: dataHtml.dateTestAcid,
                onNewTest: function (idTest) {
                    isDirtyTest = true
                    dataHtml.idTestAcid = idTest
                    if (idTest.length > 0) { dataHtml.dateTestAcid = new Date() }
                    else { dataHtml.dateTestAcid = "" }
                },
                //html: Me.mGetHtml()
            })
            jauge.mHide()
        })
    }

    this.mClearFiles = function () {
        dxCtrlFichierJoint.mClearFiles()
    }
    this.mClearFilesHeberge = function () {
        while (dataHtml.lstfileheberge.length > 0) { dataHtml.lstfileheberge.splice(0, 1) }
    }
    this.mAddFiles = function (lstUrlFile) {
        dxCtrlFichierJoint.mAddFiles(lstUrlFile)
    }
    this.mAddFilesHeberge = function (lstUrlFile) {
        lstUrlFile.forEach(function (url) { dataHtml.lstfileheberge.push(url) })
    }
    this.mChangeObjet = function (objet) {
        if (dxCtrlObjet) {
            dxCtrlObjet.mSetValue(objet) //        dxCtrlObjet.option("value", objet)
            dxCtrlObjet.isDirty = true
        }
    }
    this.mChangeLstChampsSaisie = function (lstChampSaisie) {
        dataHtml.lstChampSaisie = lstChampSaisie
        dxEmailEditor.mChangeLstSaisie(lstChampSaisie)
    }
    this.mChangeHtml = function (html, htmlSansBody, funcFin) {
        if (option.notAllowLoadConcepteur && html.contains('assistant2="1"')) {
            mNotify("Vous ne pouvez pas sélectionner un email issue d'un concepteur HTML", "warning", 6000)
            if (typeof funcFin != 'undefined') funcFin()
            return
        }
        if (option.loadConcepteurInHtml) {
            //on transforme le html de l'assistant en normal
            if (html.contains('assistant2="1"')) {
                html = html.replace('assistant2="1"', '')
            }
        }
        if (isFileData()) {
            option.data.is_assistant = ((html.contains('assistant2="1"')) ? "1" : "0")
            option.bddCtrl.getObjet(option.data).mSaveChamp("is_assistant")
        }
        while (dataHtml.lstfileheberge.length > 0) { dataHtml.lstfileheberge.splice(0, 1) }
        dxEmailEditor.mChangeHtml(html, htmlSansBody, funcFin)
    }

    this.mGetData = function () {
        var html = dxEmailEditor.mGetHtml()
        return {
            objet: ((dxCtrlObjet) ? dxCtrlObjet.mGetValue() : ""), //mGetTextObjet(), // dxCtrlObjet.option("value"),
            lstFile: dxCtrlFichierJoint.mGetLstUrlFile(),
            lstfileheberge: dataHtml.lstfileheberge,
            isAssistant: dxEmailEditor.isAssistant(),
            lstChampSaisie: dxEmailEditor.option("lstChampSaisie"),
            html: html,
            text_body: $(html).text()
        }
    }

    this.mGetHtmlUrl = function (funcOk) {
        if (typeof option.data64 != 'undefined') {
            option.bddCtrl.mAjaxCall({
                command: "gethtmlurldataemailbase64",
                data_base64: option.data64
            }, function (data) {
                funcOk(data.urlhtml)
            })
        } else if (typeof option.data.id_fichier != 'undefined') {
            option.bddCtrl.mAjaxCall({
                command: "gethtmlurldataemailfichier",
                path_nom_fichier: option.data.id_fichier
            }, function (data) {
                funcOk(data.urlhtml)
            })
        } else {
            option.bddCtrl.mAjaxCall({
                command: "gethtmlurldataemailbdd",
                nom_table: option.bddCtrl.getObjet(option.data).mGetTable().nom,
                id: option.bddCtrl.getObjet(option.data).cle()
            }, function (data) {
                funcOk(data.urlhtml)
            })
        }
    }

    var onCloseInitial = null
    function mStartSaveAuto() {
        timeOutSaveAuto = window.setTimeout(function () { Me.mSaveAuto() }, 10000)
        var popupPage = null
        if (typeof page.mGetPopupPage != 'undefined') popupPage = page.mGetPopupPage(option.data)
        if (popupPage != null) {
            onCloseInitial = popupPage.option("onClose")
            popupPage.option("onClose", function (e, funcFin) {
                Me.mStopSaveAuto(function () {
                    if (typeof onCloseInitial != 'undefined') onCloseInitial(e)
                    if (typeof funcFin != 'undefined') funcFin()
                })
            })
        }
        //if ($("body").find("." + container.closest(".dx-popup-content").attr("idpopup")).length > 0) {
        //    var popup = $("body").find("." + container.closest(".dx-popup-content").attr("idpopup")).dxPopup("instance")
        //    var onhiding = popup.option("onHiding")
        //    var firstHide = true
        //    popup.option("onHiding", function (e) {
        //        if (firstHide) {
        //            firstHide = false
        //            e.cancel = true
        //            Me.mStopSaveAuto(function () {
        //                window.setTimeout(function () { popup.hide() }, 0)
        //            })
        //        } else {
        //            if (typeof onhiding != 'undefined') onhiding(e)
        //        }
        //    })
        //}
    }
    this.saveAuto = true
    this.mStopSaveAuto = function (funcFin) {
        Me.saveAuto = false
        window.clearTimeout(timeOutSaveAuto)
        var popupPage = null
        if (typeof page.mGetPopupPage != 'undefined') popupPage = page.mGetPopupPage(option.data)
        if (popupPage != null) {
            popupPage.option("onClose", function (e, funcFin) {
                if (typeof onCloseInitial != 'undefined') onCloseInitial(e)
                if (typeof funcFin != 'undefined') funcFin()
            })
        }
        this.mSaveAuto(funcFin)
    }
    var timeOutSaveAuto = null
    this.mSaveAuto = function (funcFin, forcer) {
        if (typeof forcer == "undefined") forcer = false
        window.clearTimeout(timeOutSaveAuto)
        if (Me.isDirty() || forcer) {
            Me.mSave(function (parametre) {
                if (typeof funcFin != 'undefined') funcFin(parametre)
                if (Me.saveAuto && container.closest("body").length > 0) timeOutSaveAuto = window.setTimeout(function () { Me.mSaveAuto() }, 5000)
                if (option.onValueChanged) option.onValueChanged()
            })
        } else {
            if (typeof funcFin != 'undefined') funcFin()
            if (Me.saveAuto && container.closest("body").length > 0) timeOutSaveAuto = window.setTimeout(function () { Me.mSaveAuto() }, 5000)
        }
    }
    function isFileData() {
        var result = false
        if (typeof option.data64 != 'undefined') { }
        else if (typeof option.data.id_fichier != 'undefined') { }
        else { result = true }
        return result
    }
    this.mSave = function (funcFin) {
        if (!dxEmailEditor.isInit) { window.setTimeout(function () { Me.mSave(funcFin) }, 100) }
        else {
            Me.isDirty(false)
            if (isFileData()) {
                if (option.bddCtrl.getObjet(option.data).cle() == null) {
                    var objets = option.bddCtrl.getObjets()
                    if (option.bddCtrl.getObjet(option.data).mGetTable().nom == "ticket") objets.nomBase = parametre.code_appli + "_aagest"
                    objets.mAddData([option.data], "save")
                    objets.mSave(function () { mSaveEmailBase() })
                } else { mSaveEmailBase() }
            } else { mSaveEmailBase() }

            function mSaveEmailBase() {
                var lstFile = []
                dxCtrlFichierJoint.mGetLstUrlFile().forEach(function (file) {
                    lstFile.push({ url: file })
                })
                var lstFileHebergeToSave = []
                dataHtml.lstfileheberge.forEach(function (file) {
                    lstFileHebergeToSave.push({ url: file })
                })

                var opt = {
                    //objet: dxCtrlObjet.mGetValue(), //mGetTextObjet(), // ((dxCtrlObjet.option("value") == null) ? "" : dxCtrlObjet.option("value")),
                    html: dxEmailEditor.mGetHtml(),
                    lstfile: lstFile,
                    lstfileheberge: lstFileHebergeToSave,
                    idtestacid: dataHtml.idTestAcid, // dxEmailEditor.mGetIdTestAcid()
                    lst_champ_saisie: JSON.stringify(dataHtml.lstChampSaisie)
                }

                if (!(typeof option.showObjet != 'undefined' && !option.showObjet)) opt.objet = dxCtrlObjet.mGetValue()
                if (typeof option.data64 != 'undefined') {
                    opt.command = "savedataemail_fichierBase64"
                    //opt.data_base64 = option.data64
                } else if (typeof option.data.id_fichier != 'undefined') {
                    opt.command = "savedataemail_fichier"
                    opt.path_nom_fichier = option.data.id_fichier
                } else {
                    opt.command = "savedataemail_data"
                    opt.nom_table = option.bddCtrl.getObjet(option.data).mGetTable().nom
                    opt.id = option.bddCtrl.getObjet(option.data).cle()
                }

                option.bddCtrl.mAjaxCall(opt, function (data) {
                    if (opt.command == "savedataemail_fichier") $(window).trigger("updatelstfile");
                    if (typeof data.bddupdate != 'undefined' && typeof option.data != 'undefined') {
                        var nomTable = Object.keys(data.bddupdate)[0]
                        var id = data.bddupdate[nomTable][0]["id_" + nomTable]
                        option.data.body_txt = data.bddupdate[nomTable][0].body_txt
                        option.data.nb_fichier_joint = data.bddupdate[nomTable][0].nb_fichier_joint
                        option.data.taille_octet = data.bddupdate[nomTable][0].taille_octet
                        option.data.taille_octet_ss_image = data.bddupdate[nomTable][0].taille_octet_ss_image
                        option.data.objet = data.bddupdate[nomTable][0].objet
                    } else if (opt.command == "savedataemail_fichier") {
                        option.data.taille_octet = data.taille_octet
                        option.data.taille_octet_ss_image = data.taille_octet_ss_image
                    }
                    if (typeof data.id_fichier != 'undefined') option.path_nom_fichier = data.id_fichier
                    if (typeof data.path_nom_fichier != 'undefined') option.path_nom_fichier = data.path_nom_fichier
                    if (isFileData()) {
                        option.bddCtrl.triggerFunctionOnModifiedItemData(option.bddCtrl.getObjet(option.data).mGetTable().nom, "modif", data.bddupdate[option.bddCtrl.getObjet(option.data).mGetTable().nom][0])
                    } else if (opt.command == "savedataemail_fichierBase64") {
                        if (typeof funcFin != 'undefined') funcFin(data.base64string)
                    }
                    if (typeof option.onSave != 'undefined') option.onSave()
                }, function (data) {
                    if (opt.command != "savedataemail_fichierBase64" && typeof funcFin != 'undefined') funcFin()
                })
            }
        }
    }

    this.mDemandeExport = function (nomFichierSansExtension, pathNomFichier,extension) {
        $("<div/>").dxCtrlPopupEnregistrerSous({
            bddCtrl: option.bddCtrl,
            extension: extension,
            mode: "single",
            type: "enregistrersous",
            selectedDirectory: option.bddCtrl.repertoireBrouillon,
            fileNameWithoutExtension: nomFichierSansExtension,
            title: "Enregistrer sous...",
            onValide: function (lstPathName) {
                var pathName = lstPathName[0]
                if (pathName == pathNomFichier) {
                    Me.mExportBox(pathName, function () {
                        mNotify("Votre document a été sauvegardé", "success", 6000)
                    })
                } else {
                    mVerifFileExist(option.bddCtrl, pathName, function (exist) {
                        if (exist) {
                            mConfirmPopup("<div style='padding-bottom:20px;'>Le fichier que vous avez choisi<br/>existe déjà.<br/><br/>Voulez-vous remplacer le fichier<br/>avec votre document ?</div>", function () {
                                Me.mExportBox(pathName, function () {
                                    mNotify("Votre document a été sauvegardé", "success", 6000)
                                })
                            })
                        } else {
                            Me.mExportBox(pathName, function () {
                                mNotify("Votre document a été sauvegardé", "success", 6000)
                            })
                        }
                    })
                }

            }
        })
    }

    this.mExportBox = function (pathNomFichier, funcFin) {
        var lstFile = []
        dxCtrlFichierJoint.mGetLstUrlFile().forEach(function (file) {
            lstFile.push({ url: file })
        })
        var lstFileHebergeToSave = []
        dataHtml.lstfileheberge.forEach(function (file) {
            lstFileHebergeToSave.push({ url: file })
        })
        var opt = {
            objet: ((dxCtrlObjet) ? dxCtrlObjet.mGetValue() : ""), //mGetTextObjet(), // ((dxCtrlObjet.option("value") == null) ? "" : dxCtrlObjet.option("value")),
            html: dxEmailEditor.mGetHtml(),
            lstfile: lstFile,
            lstfileheberge: lstFileHebergeToSave,
            lstChampSaisie: JSON.stringify(dataHtml.lstChampSaisie)
        }
        opt.command = "savedataemail_fichier"
        opt.path_nom_fichier = pathNomFichier
        option.bddCtrl.mAjaxCall(opt, function (data) {
            funcFin()
        }, function (data) {
        })
    }

    this.focus = function () {
        if (option.readOnly) return;
        if (dataHtml != null && (dataHtml.objet == null || dataHtml.objet.length == 0) && option.objetVisible && dxCtrlObjet) { dxCtrlObjet.focus() }//dxCtrlObjet.focus() }
        else {
            if (dxEmailEditor) dxEmailEditor.focus()
        }
    }
    this.element = function () { return container }
    //this.dispose = function () {
    //    if (dxCtrlObjet) dxCtrlObjet.dispose()
    //    if (dxCtrlFichierJoint) dxCtrlFichierJoint.dispose()
    //    if (dxEmailEditor) dxEmailEditor.dispose()
    //}

    mConstruit();
}